import React, { useState } from "react";
import { Form, Switch, Descriptions, Upload, Icon, Button } from "antd";
import { connect } from "react-redux";
import { updateCurrentUserAction } from "../../redux/actions";
import { alertify, handleApiExceptions, size_greater_than } from '../../app_methods';
import { Text4 } from "../../styles";
import TaxPayments from './tax_payments';
import { MerchantService } from "../../services";
import { PermissionHoc } from "../HOC";

const PermissableUpload = PermissionHoc(Upload.Dragger,"SETTINGS_WRITE_WHITE_LABEL",{ is_component: true, fallbackComponent: null })


let GeneralSettings = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const file = props.form.getFieldValue('file') || null;
    const [isSaving, setIsSaving] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };
    
    const switchBulkUploadUpdate = async (checked) => {
        setIsSaving(true);
        const response = await MerchantService.save_bulk_upload_settings({
            enable_bulk_upload_approval_flow: checked,
            key: props.current_user.key,
        });
        if (!response.success) {
            handleApiExceptions(response);
            return;
        }
        setIsSaving(false);
        fetchMerchantInfo();

    };


    const onSubmit = (e) => {
        // e.preventDefault();
        form.validateFields(async (err, values) => {
            if (err) return;
            if (!values.file) return;
            if (values.file.file.type.indexOf("image") == -1) {
                handleApiExceptions("Only Image Extension files are allowed to upload.");
                return;
            }
            setIsUploading(true);
            const response = await MerchantService.save_settings({ ...values, key: props.current_user.key });
            if (!response.success) {
                setIsUploading(false);
                handleApiExceptions(response);
                return;
            }
            // alertify("Success", "Settings saved successfully.", "success");
            setIsUploading(false);
            fetchMerchantInfo();
        });
    };

    return (
        <div style={{width: "40%"}}>
            <Descriptions column={1} bordered size={'small'}>
                <Descriptions.Item label={"Approval on Bulk Operations"}>
                    <Switch className="" onChange={switchBulkUploadUpdate} disabled={isSaving} defaultChecked={props.current_user.ebpa} />
                </Descriptions.Item>
                {(props.current_user.gtp || props.current_user.tdtp) ?
                    <Descriptions.Item label={"Approval on Tax Payments"}>
                        <TaxPayments />
                    </Descriptions.Item> : null}
                {(props.current_user.is_reseller || props.current_user.eum)?
                    <Descriptions.Item label={"Merchant Login URL"}>
                        <Text4 copyable>{props.current_user.white_label_setting && props.current_user.white_label_setting.login_url}</Text4>
                    </Descriptions.Item> : null}
                    <Descriptions.Item label={"Logo"}>
                    <Form onChange={onSubmit}>
                    <div className="white-label-logo-upload">
                            <Form.Item>
                                {getFieldDecorator('file', {
                                    valuePropName: 'file',
                                    rules: [{
                                        validator: (rule, value, callback) => {
                                            if (!value) {
                                                callback(true);
                                                return;
                                            }
                                            //const file = value.fileList[value.fileList.length-1];
                                            const file = value.file;
                                            size_greater_than(file, 1000000) ? callback(true) : callback();
                                        },
                                        message: "File size cannot exceed 1 MB"
                                    }]
                                })(
                                    <PermissableUpload loading={isUploading}
                                        name='file'
                                        multiple={false}
                                        showUploadList={false}
                                        className="pl-0 d-block"
                                        beforeUpload={(file) => {
                                            return false;
                                        }}
                                        accept="image/*"
                                    >
                                        {
                                            props.current_user.white_label_setting && props.current_user.white_label_setting.logo_url ?
                                                <div style={{ margin: "auto", width: 160, height: "auto", overflow: "hidden", textAlign: "center", maxHeight: 65 }}>
                                                    <img style={{ margin: "auto", width: "auto", maxWidth: 150, maxHeight: 65 }} src={props.current_user.white_label_setting.logo_url} />
                                                </div>
                                                :
                                                <p className="ant-upload-drag-icon"><Icon type="inbox" /></p>
                                        }
                                        {
                                            file ? (
                                                <div className="mt-2 file-name-elipses">
                                                    <Text4 strong>Selected File:</Text4>
                                                    <Text4 className="ml-2">
                                                        {(file || {}).fileList[(file || {}).fileList.length - 1].name}
                                                    </Text4>
                                                </div>
                                            ) : <div className="mt-2">
                                                    <Text4 className="d-block">Click or drag file to this area to upload</Text4>
                                                </div>
                                        }
                                    </PermissableUpload>
                                )}
                            </Form.Item>
                        </div>
                    </Form>
                    </Descriptions.Item>

            </Descriptions>
        </div>
    );
};


GeneralSettings = Form.create()(GeneralSettings);

const mapStateToProps = (state) => ({
    current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
    updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettings);